import {
  ALERT_TYPES,
  BpkBannerAlertDismissable,
} from '@skyscanner-internal/backpack-web/bpk-component-banner-alert';
import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';
import {
  BpkBox,
  BpkSpacing,
  BACKGROUND_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import { useDispatch, useSelector } from 'react-redux';

import { dismissNoDirectsMsg } from '../../actions/ui-actions';
import { useMediaQuery } from '../../helpers/hooks/useMediaQuery';
import { useTranslation } from '../../helpers/hooks/useTranslation';
import {
  isDirectAvailable,
  isLoading,
  isNoDirectsMessageDismissed,
  isPreferDirectsOverridden,
} from '../../selectors';

import type { State } from '../../selectors/types';

const NoDirectsMessage = (): JSX.Element | null => {
  const isMobilePhone = useMediaQuery(BREAKPOINTS.MOBILE);
  const translate = useTranslation();
  const dispatch = useDispatch();
  const directAvailable = useSelector((state: State) =>
    isDirectAvailable(state),
  );
  const preferDirectsOverridden = useSelector((state: State) =>
    isPreferDirectsOverridden(state),
  );
  const noDirectsMessageDismissed = useSelector((state: State) =>
    isNoDirectsMessageDismissed(state),
  );

  const gridLoading = useSelector((state: State) => isLoading(state));
  const visible =
    !directAvailable &&
    preferDirectsOverridden &&
    !noDirectsMessageDismissed &&
    !gridLoading;

  const message = translate('no_directs_found');

  const onCloseButtonClick = (): void => {
    dispatch(dismissNoDirectsMsg());
  };

  if (!visible) return null;

  return (
    <BpkBox
      paddingInline={isMobilePhone ? BpkSpacing.MD : BpkSpacing.None}
      paddingBottom={BpkSpacing.Base}
      backgroundColor={
        isMobilePhone ? BACKGROUND_COLORS.surfaceDefault : undefined
      }
    >
      <BpkBannerAlertDismissable
        message={message}
        type={ALERT_TYPES.WARN}
        dismissButtonLabel="Dismiss" // TODO: Translate this
        onDismiss={onCloseButtonClick}
      />
    </BpkBox>
  );
};

export default NoDirectsMessage;
